import React, { useState, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import chatIcon from '../../../../../../assets/svg/chat.svg';
import { store as mainStore } from '../../../../../../store';
import { store } from './Driver';
import axios from '../../../../../../api/axios';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {},
  field: {
    background: `url(${chatIcon}) no-repeat`,
    backgroundSize: '50px',
    backgroundPosition: '10px',
  },
}));

function SendMessageForm() {
  const [text, setText] = useState('');
  const { id: userId } = useParams();
  const { showMessage, showError } = useContext(mainStore);
  const { state, dispatch } = useContext(store);
  const { fetchingSms, fetchingMessages, allSms, messages } = state;
  const [sending, setSending] = useState(false);

  const handleChangeText = (e) => {
    let { value } = e.target;
    setText(value);
  };
  const handleSendSMS = async () => {
    try {
      if (!text) throw 'متن پیامک خود را وارد نمائید';
      setSending('sms');
      const { data } = await axios.post(`/api/v1/admin/users/sendSMS`, {
        userId,
        text,
      });
      const s = await fetchingSms(userId, allSms.page, allSms.limit);
      dispatch({ type: 'LOAD', payload: { name: 'allSms', value: s } });
      setSending(false);
      setText('');
      showMessage(data.messages);
    } catch (error) {
      showError(error);
      setSending(false);
    }
  };

  const handleSendNotification = async () => {
    try {
      if (!text) throw 'متن پیامک خود را وارد نمائید';
      setSending('notification');
      const { data } = await axios.post(`/api/v1/admin/users/sendMessage`, {
        userId,
        text,
      });
      const m = await fetchingMessages(userId, messages.page, messages.limit);
      dispatch({ type: 'LOAD', payload: { name: 'messages', value: m } });
      setSending(false);
      setText('');
      showMessage(data.messages);
    } catch (error) {
      showError(error);
      setSending(false);
    }
  };

  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Grid container direction="column" spacing={1}>
        <Grid item>
          <Typography component="h2" variant="h2">
            پیام به کاربر:
          </Typography>
        </Grid>
        <Grid item>
          <TextField
            fullWidth
            label="متن پیغام جهت ارسال به کاربر"
            variant="outlined"
            color="primary"
            multiline
            size="small"
            rows={3}
            className={classes.field}
            onChange={handleChangeText}
            value={text}
          />
        </Grid>
        <Grid item>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Button
                variant="contained"
                fullWidth
                size="medium"
                color="secondary"
                onClick={handleSendSMS}
                disabled={sending ? true : false}
              >
                {sending === 'sms' ? 'درحال ارسال پیامک' : 'پیامک'}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                fullWidth
                size="medium"
                color="secondary"
                onClick={handleSendNotification}
                disabled={sending ? true : false}
              >
                {sending === 'notification' ? 'درحال ارسال ...' : 'نوتیفیکیشن'}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default SendMessageForm;
